<template>
  <el-date-picker
    class="date-picker"
    @change="change"
    :style="`width: ${width}`"
    :picker-options="pickerOptions"
    v-model="tempData"
    :type="dateType"
    :value-format="`yyyy-MM-dd${dateType==='datetime' ? ' HH:mm:ss' : ''}`"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
  export default {
    name: "DatePicker",
    model: {
      event: 'change',
    },
    props: {
      value: String,
      type: String,
      width: {
        type: String,
        default: "100%",
      },
      dateType: {
        type: String,
        default: "date",
      },
    },
    data() {
      return {
        tempData: this.value,
        pickerOptions: {},
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    methods: {
      getDisabledDate(type) {
        switch (type) {
          case "after": return time => time.getTime() < Date.now() - 8.64e7;
          case "before": return time => time.getTime() > Date.now();
          default: return () => {};
        }
      },
      change(val) {
        this.$emit("change", val || "");
      },
    },
    created() {
      this.pickerOptions.disabledDate = this.getDisabledDate(this.type);
    }
  }
</script>

<style lang="scss">
  .date-picker {
    input {
      cursor: pointer;
    }
  }
</style>
